var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFerryShuttle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#000000;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "3,12.8 2.6,10.4 1.5,8 8.1,6.1 14.5,7.9 13.5,10.4 13.3,12.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.1,7.2V3.8C4.1,3.3,4.4,3,4.9,3h6.5c0.5,0,0.9,0.4,0.9,0.9v3.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.1,
    y1: 3,
    x2: 8.1,
    y2: 1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 4.7,
    y1: 9.1,
    x2: 4.7,
    y2: 10.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 11.5,
    y1: 9.1,
    x2: 11.5,
    y2: 10.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1,13.3c0.2,0.2,1,0.9,2.3,0.9c1.1,0.1,2-0.4,2.4-0.7c0.1-0.1,0.4-0.1,0.5,0c0.2,0.2,0.6,0.4,1.1,0.5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 12.2,
    y1: 16.1,
    x2: 12.2,
    y2: 12.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 10.6,
    cy: 21,
    r: 1.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.1,21H8.6c-0.7,0-1.2-0.5-1.2-1.2V16v-2.5c0-0.7,0.5-1.2,1.2-1.2h3.7h5.7h2.4c0.5,0,0.9,0.2,1.1,0.7 l1.3,2.4c0.1,0.2,0.2,0.4,0.2,0.6v0.1v1.8v1.8c0,0.7-0.5,1.2-1.2,1.2h-0.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 17.9,
    y1: 21,
    x2: 12.2,
    y2: 21
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "22.8,16.1 18,16.1 12.2,16.1 7.3,16.1  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 18,
    y1: 16.1,
    x2: 18,
    y2: 12.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 19.4,
    cy: 21,
    r: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 22.8,
    y1: 17.9,
    x2: 22,
    y2: 17.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFerryShuttle);
export default __webpack_public_path__ + "static/media/ferry-shuttle.5cfcbf6a58585ae80a235ee4405e3a4f.svg";
export { ForwardRef as ReactComponent };